module.exports = __webpack_public_path__ + "static/media/johngilbert_resume_cht.eb73fd1d.jpg";